import React, { useEffect, useState, useId } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next';

export function AutocompleteSearch({ dataList, optionLabel, labelText, onChangeHanddle, disabled, required }) {

  const autocompleteId = useId();
  const [value, setValue] = useState()
  const { t } = useTranslation();

  const onChangeHandleInner = (value) => {
    onChangeHanddle(value)
    setValue(value)
  }

  useEffect(() => {
    setValue()
  }, [dataList])

  return (
    <Autocomplete
      id={autocompleteId}
      options={dataList}
      getOptionLabel={optionLabel}
      noOptionsText={t("AutoCompleteSearch.noHayCoincidencias")}
      onChange={(e, value) => onChangeHandleInner(value)}
      renderInput={(params) => <TextField required={required} {...params} label={labelText} />}
      disabled={disabled}
      sx={{
        width: { sm: "100%" },
      }}
      key={value}
      value={value}
    />
  )
}

